<template>
    <v-card>
     <v-card-title>
       <v-icon x-large>mdi-alarm-off</v-icon>
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="users"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900px">
          <!--<template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                     <v-col cols="12" sm="6" md="6">
                      <v-text-field readonly v-model="editedItem.TimeOut_id"
                        label="ID TimeOut" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.TimeOut_tm"
                        :rules="RuleTimeOut_tm"
                        type="time"
                        step="2"
                        label="Tiempo"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_pass" max-width="900px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn color="accent" text @click="save_pwd">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_new" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">NUEVO TIMEOUT</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.TimeOut_tm"
                        :rules="RuleTimeOut_tm"
                        type="time"
                        step="2"
                        label="Tiempo"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="accent" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    search: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    valid: true,
    headers: [
      { text: 'Id TimeOut', value: 'TimeOut_id' },
      { text: 'Tiempo', value: 'TimeOut_tm' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    idtimeout:'',
    users: [],
    editedIndex: -1,
    editedItem: {
      TimeOut_id: this.idtimeout,
      TimeOut_tm: '00:01:00',
      TimeOut_Sg: ''
    },
    defaultItem: {
      TimeOut_id: this.idtimeout,
      TimeOut_tm: '00:01:00',
      TimeOut_Sg: ''
    },
    ruleID: [
      v => !!v || 'ID es requerido'
    ],
    RuleTimeOut_tm: [
      v => !!v || 'Tiempo es requerido'
    ],
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo TimeOut' : 'Editar TimeOut'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      axios.post(this.api_tool_url + '/get_timeout', {}, this.config)
        .then(response => {
          this.users = response.data.ResultRows
        })
        .catch(error => {
          this.users = []
          alert(error.response.data.message)
        })
    },

    newtItem (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_new = true
    },

    editItem (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.users.indexOf(item)
      confirm('Esta seguro que quiere eliminar?') && this.deleteUser(index)
    },

    deleteUser (index) {
      let userTmp = this.users[index]
      axios.post(this.api_tool_url + '/del_timeout', userTmp, this.config)
        .then(response => {
          this.users = []
          this.users = response.data.ResultRows
          this.$store.commit('updateUser_TimeOut',response.data.ResultRows[0])
          this.close()
        })
        .catch(error => {
          this.users = []
          alert(error.response.data.message)
        })
    },

    close () {
      this.dialog = false
      this.dialog_pass = false
      this.dialog_new = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        axios.post(this.api_tool_url + '/upd_timeout', this.editedItem, this.config)
          .then(response => {
            this.users = []
            this.users = response.data.ResultRows
            this.$store.commit('updateUser_TimeOut',response.data.ResultRows[0])
            this.close()
          })
          .catch(error => {
            this.users = []
            alert(error.response.data.message)
          })
        // Object.assign(this.users[this.editedIndex], this.editedItem)
      } else {
        axios.post(this.api_tool_url + '/ins_timeout', this.editedItem, this.config)
          .then(response => {
            // console.log(response)
            this.users = []
            this.users = response.data.ResultRows
            this.$store.commit('updateUser_TimeOut',response.data.ResultRows[0])
            this.close()
          })
          .catch(error => {
            this.users = []
            alert(error.response.data.message)
          })
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TimeoutGrid.vue